<template>
    <div class="navTitle">
        <div class="head">
            <div class="headLeft">
                <div class="price">¥????<span class="price">¥{{ goods.sellPrice }}</span></div>
            </div>
            <div class="headRight">
                <div class="describe" v-text="timeHtml"></div>
                <div class="time">
                    <vantCountDown @onCountDown="onCount" :time="timeDown"></vantCountDown>
                </div>
            </div>
        </div>
        <div class="title">
            <div class="content"><span v-text="goods.skuShowName"></span></div>
            <div class="share" @click="onShareGoods">
                <img src="../../../../assets/img/b2b/icon_share.png" alt="">
                <p>分享</p>
            </div>
        </div>
    </div>
</template>

<script>
import vantCountDown from '../homeCountDown'
export default {
    components: {
        vantCountDown
    },
    props: {
        // 商品信息对象
        goods: {
            type: Object,
            default: () => {
                return {}
            }
        },
        // 倒计时文案显示
        timeHtml: {
            type: String,
            default: ''
        },
        // 倒计时时间戳
        timeDown: {
            type: Number,
            defautl: 1000
        }
    },
    methods: {
        onCount () {
            this.$emit('onCount')
        },
        // 点击分享
        onShareGoods () {
            this.$emit('onShareGoods')
        }
    }
}
</script>
<style lang="scss" scoped>
.navTitle {
    font-family: PingFangSC-Medium, PingFang SC;
    .head {
        height: 88px;
        color: #ffffff;
        display: flex;
        justify-content: space-between;
        background: #ff4d4f;
        padding-left: 32px;
        padding-right: 24px;
        .headLeft {
            font-size: 32px;
            box-sizing: border-box;
            line-height: 88px;
            .price {
                font-size: 36px;
                font-family: PingFangSC-Medium, PingFang SC;
                span {
                    display: inline-block;
                    padding-left: 16px;
                    font-size: 24px;
                    text-decoration: line-through;
                }
            }
        }
        .headRight {
            font-size: 24px;
            color: #ffffff;
            line-height: 88px;
            display: flex;
            .describe {
                position: relative;
                &::before {
                    content: "";
                    position: absolute;
                    background: url(../../../../assets/img/b2b/time4.png)
                        no-repeat;
                    background-size: 100% 100%;
                    width: 32px;
                    height: 32px;
                    left: -36px;
                    top: 26px;
                }
            }
            /deep/ .van-count-down {
                line-height: inherit;
                font-size: 24px;
                color: #ffffff;
            }
            .time {
                text-align: center;
                padding: 0 10px;
            }
        }
    }
    .title {
        padding: 28px 96px 28px 32px;
        font-family: PingFangSC-Medium, PingFang SC;
        background: #ffffff;
        position: relative;
        .content {
            position: relative;
            line-height: 42px;
            min-height: 88px;
            font-size: 30px;
            color: #333333;
            font-weight: 500;
            word-wrap: break-word;
            word-break: break-all;
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            .iconPic {
                background: url(../../../../assets/img/b2b/imgs_label_Invite_new@2x.png)
                    no-repeat;
                background-size: 100% 100%;
                width: 72px;
                height: 32px;
                display: inline-block;
                position: relative;
                top: 4px;
                margin-right: 8px;
            }
        }
        .share {
            position: absolute;
            top: 32px;
            right: 32px;
            height: 48px;
            font-size: 0;
            color: #ff7a45;
            p {
                font-size: 22px;
                transform: scale(0.93);
            }
        }
    }
}
</style>
